export enum ActionTypes {
  DELETABLE = 'deletable',
  UPDATABLE = 'updatable',
  CREATABLE = 'creatable',
  READABLE = 'readable',
}
